import { t } from "@web-monorepo/i18n/macro";
import ToolkitCard from "components/ToolkitCard";
import CountdownControls from "./CountdownControls";
import CountdownTime from "./CountdownTime";
import { useCountdownCard, type UseCountdownCardProps, type UseCountdownCardResult } from "./useCountdownCard.vm";

const alarm = "/static/media/timer-complete.mp3";
const alarmCaptions = "/static/media/timer-complete.vtt";

type CountdownCardProps = {
  seconds: number;
  goBack: VoidFunction;
  /**
   * Dependency injection for the view model — Storybook stories override this
   * with a stub `useVm` returning canned state. Production callers leave the
   * default.
   */
  di?: {
    useVm?: (props: UseCountdownCardProps) => UseCountdownCardResult;
  };
};

export default function CountdownCard({ seconds, goBack, di }: CountdownCardProps) {
  const useVm = di?.useVm ?? useCountdownCard;
  const { secondsRemaining, icon, toggle, restart, incrementTimer, audioRef } = useVm({
    initialSeconds: seconds,
  });

  return (
    <ToolkitCard close={goBack}>
      <CountdownTime seconds={secondsRemaining} />
      <audio src={alarm} ref={audioRef}>
        <track kind="captions" src={alarmCaptions} srcLang="en" label={t`English`} default />
      </audio>
      <CountdownControls
        seconds={secondsRemaining}
        icon={icon}
        toggle={toggle}
        restart={restart}
        incrementTimer={incrementTimer}
      />
    </ToolkitCard>
  );
}
